import type { ReactNode } from 'react';

/**
 * Le contrôle est imbriqué dans le label : l'association est faite sans
 * identifiant à gérer.
 */
export function Field({
  label,
  hint,
  wide = false,
  children,
}: {
  label: string;
  hint?: string;
  wide?: boolean;
  children: ReactNode;
}) {
  return (
    <label className={wide ? 'champ champ--large' : 'champ'}>
      <span className="champ__libelle">{label}</span>
      {children}
      {hint !== undefined && <span className="champ__aide">{hint}</span>}
    </label>
  );
}
